import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import FaviconLoader from "@/components/FaviconLoader";
import InstallPrompt from "@/components/InstallPrompt";
import IdleWatch from "@/components/IdleWatch";
import LoginPage from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/components/AppLayout";
import EmployeeDashboard from "@/pages/employe/Dashboard";
import EmployeeToday from "@/pages/employe/Today";
import EmployeeHome from "@/pages/employe/Home";
import EmployeeLeaves from "@/pages/employe/Leaves";
import EmployeeCertificates from "@/pages/employe/Certificates";
import EmployeePayslips from "@/pages/employe/Payslips";
import EmployeeVault from "@/pages/employe/Vault";
import TeamPage from "@/pages/Team";
import TeamCalendar from "@/pages/TeamCalendar";
import ProfilePage from "@/pages/Profile";
import TechDocs from "@/pages/TechDocs";
import RHDashboard from "@/pages/rh/Dashboard";
import RHLeaves from "@/pages/rh/Leaves";
import RHCertificates from "@/pages/rh/Certificates";
import RHPayslips from "@/pages/rh/Payslips";
import RHEmployees from "@/pages/rh/Employees";
import RHAuditLogs from "@/pages/rh/AuditLogs";
import RHCompanySettings from "@/pages/rh/CompanySettings";
import RHLeaveSettings from "@/pages/rh/LeaveSettings";
import RHLoginJournal from "@/pages/rh/LoginJournal";
import VerifyCertificate from "@/pages/VerifyCertificate";

const Protected = ({ children, role }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "rh" ? "/rh" : "/"} replace />;
  return children;
};

const RootRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "rh" ? "/rh" : "/employe"} replace />;
};

function FaviconGate() {
  const { user } = useAuth();
  if (!user) return null;
  return <FaviconLoader />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <FaviconGate />
        <InstallPrompt />
        <IdleWatch />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify/:signatureId" element={<VerifyCertificate />} />
          <Route path="/" element={<RootRedirect />} />

          <Route path="/employe" element={<Protected role="employe"><AppLayout /></Protected>}>
            <Route index element={<EmployeeHome />} />
            <Route path="tableau-de-bord" element={<EmployeeDashboard />} />
            <Route path="aujourdhui" element={<EmployeeToday />} />
            <Route path="conges" element={<EmployeeLeaves />} />
            <Route path="attestations" element={<EmployeeCertificates />} />
            <Route path="bulletins" element={<EmployeePayslips />} />
            <Route path="coffre-fort" element={<EmployeeVault />} />
            <Route path="equipe" element={<TeamPage />} />
            <Route path="calendrier" element={<TeamCalendar />} />
            <Route path="profil" element={<ProfilePage />} />
            <Route path="documents-pro" element={<TechDocs />} />
          </Route>

          <Route path="/rh" element={<Protected role="rh"><AppLayout /></Protected>}>
            <Route index element={<RHDashboard />} />
            <Route path="conges" element={<RHLeaves />} />
            <Route path="attestations" element={<RHCertificates />} />
            <Route path="bulletins" element={<RHPayslips />} />
            <Route path="employes" element={<RHEmployees />} />
            <Route path="journal" element={<RHAuditLogs />} />
            <Route path="connexions" element={<RHLoginJournal />} />
            <Route path="parametres" element={<RHCompanySettings />} />
            <Route path="parametres-conges" element={<RHLeaveSettings />} />
            <Route path="equipe" element={<TeamPage />} />
            <Route path="calendrier" element={<TeamCalendar />} />
            <Route path="profil" element={<ProfilePage />} />
            <Route path="documents-pro/:userId" element={<TechDocs />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
